module.exports = __webpack_public_path__ + "static/media/scale_plate.db2c91bc.svg";